import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/policy/img/block1_授权单位查询结果.png")